<div class="row">
  <div class="col-sm-12">
    <div class="card o-hidden welcome-card">
      <div class="card-body">
        <h4 class="mb-3 mt-1 f-w-500 mb-0 f-22">
          Hello Jashmin<span> <img src="assets/images/dashboard-3/hand.svg" alt="hand vector" /></span>
        </h4>
        <p>{{ 'Learn something new every day with world's best courses.Free online courses available.' | translate }}</p>
      </div>
      <img class="welcome-img" src="assets/images/dashboard-3/widget.svg" alt="search image" />
    </div>
  </div>
  <div class="col-sm-6">
    <app-courses [data]="completed"></app-courses>
  </div>
  <div class="col-sm-6">
    <app-courses [data]="progress"></app-courses>
  </div>
</div>
